import { TesterAspect } from './tester.aspect';

export { Tests } from './tester';
export type { TesterEnv } from './tester-env';
export type {
  Tester,
  TesterContext,
  CallbackFn,
  SpecFiles,
  ComponentPatternsMap,
  ComponentsResults,
  ComponentPatternsEntry,
} from './tester';
export type { TesterMain } from './tester.main.runtime';
export type { TesterUI, EmptyStateSlot } from './tester.ui.runtime';

export { TesterAspect };
export default TesterAspect;
